import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles} from "@webs/components-library/theming";

@customElement('webs-link-arrow')
export class LinkArrow extends LitElement {

  static styles = [
    normalizeStyles,
    css`
      :host {
      --webs-button-background-color: var(--color-base);
      --webs-button-border-radius: 2.1rem;
      --webs-button-color: var(--color-white);
      --webs-button-font-family: var(--font-family-alternative);
      --webs-button-font-weight: var(--font-weight-strong);
      --webs-button-padding: .65rem 1.5rem;
    }

    .link_arrow {
      align-items: center;
      color: var(--color-base);
      cursor: pointer;
      display: inline-flex;
      font: var(--font-weight-strong) .8rem/0.8 var(--font-family-alternative);
      justify-content: center;
      line-height: 1.2;
      outline: none;
      overflow: hidden;
      position: relative;
      text-decoration: none;
      transition: color .1s linear;
      z-index: 1;
    }

    .link_arrow svg { margin-left: .3rem; transform: translateY(2px); }
    .link_arrow svg circle { transition: fill .1s linear; }

    .link_arrow:hover { color: var(--color-action); }
    .link_arrow:hover svg circle { fill: var(--color-action); }
    `
    ]

  @property()
  href: string;
  @property({attribute: 'new-tab', type: Boolean})
  openInNewTab = false;
  @property()
  rel: string;
  @property()
  text: string;
  @property()
  type: string;

  protected render(): unknown {
    return html`
      <a part="link-arrow" class="link_arrow ${this.type ? 'link_arrow--' + this.type : ''}" href="${this.href}"
         target="${this.openInNewTab ? '_blank' : ''}"
         rel="${this.rel ? this.rel : ''}">
        ${this.text}
        <svg  width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle part="circle" cx="7.5" cy="6" r="2" fill="#181A23"/>
          <circle part="circle" cx="2" cy="2.75" r="2" fill="#181A23"/>
          <circle part="circle" cx="2" cy="9.25" r="2" fill="#181A23"/>
        </svg>
      </a>`
  }
}
